import React from 'react';
import { WEDDING_DATE_DISPLAY, WEDDING_LOCATION } from '../constants/wedding';

const Hero: React.FC = () => {
    return (
        <div className="relative h-lvh">
            <div className="relative h-full flex items-center justify-center text-center text-white">
                <div className="animate-fade-in mb-28">
                    <h1 className="font-erotica">Save the da<span
                        style={{fontFeatureSettings: '"aalt" 11'}}>t</span><span
                        style={{fontFeatureSettings: '"ss04"'}}>e</span></h1>
                    <p className="font-elza-medium -mt-14 md:-mt-20 md:ml-11">{WEDDING_LOCATION}</p>
                    <p className="-mt-2 mb-4 md:ml-11 font-[100]">{WEDDING_DATE_DISPLAY}</p>
                </div>
            </div>
            {/* Desktop: Mouse scroll indicator */}
            <div className="hidden md:block absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
                <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
                    <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
                </div>
            </div>

            {/* Mobile: Hand scroll gesture */}
            <div className="md:hidden absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
                <div className="flex flex-col items-center">
                    {/* Hand icon using SVG */}
                    <svg
                        className="w-8 h-8 text-white animate-pulse"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            d="M18.5 12c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v2.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v4c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V8c0-.83-.67-1.5-1.5-1.5S4 7.17 4 8v8.5c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4V12z"/>
                        <path d="M8 6c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1z"/>
                    </svg>
                    {/* Swipe up indicator lines */}
                    <div className="flex flex-col space-y-1 mt-2">
                        <div className="w-0.5 h-2 bg-white rounded-sm animate-pulse opacity-60"></div>
                        <div className="w-0.5 h-1 bg-white rounded-sm animate-pulse opacity-40"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;
